import { defaultHeaders } from './defaultHeaders';

import type { AdsRetrievalHeaderVariables } from './defaultHeaders';
import type { RequestInit } from '@web-platform/shared-universal-types/src/network/internals/types';

const ADS_RETRIEVAL_SERVICE_ENDPOINT = '/g/ars/public/api/v2/request';

export type AdsRetrievalServiceTransformVariables = AdsRetrievalHeaderVariables &
  Record<string, unknown>;

export function adsRetrievalService(variables: AdsRetrievalServiceTransformVariables): RequestInit {
  const { channel: _channel, viewId, ...body } = variables;

  return {
    method: 'post',
    headers: defaultHeaders({ viewId }),
    mode: 'cors',
    url: ADS_RETRIEVAL_SERVICE_ENDPOINT,
    body,
  };
}
